import React from 'react';
import { CircularProgress, Paper, Typography } from '@mui/material';

export const LoadingIndicator: React.FC = () => (
  <Paper variant="loadingPaper">
    <CircularProgress />
    <Typography>Loading...</Typography>
  </Paper>
);
